module.exports = __webpack_public_path__ + "static/media/6.eb3ce444.png";